define('view/request.lock.modal.view',['require','exports','module','underscore','uikit/uikit','fukit','handlebars','moment','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _                                 = require('underscore'),
      UIKit                             = require('uikit/uikit'),
      ExtendUtil                        = require('fukit').ExtendUtil,
      Handlebars                        = require('handlebars'),
      Moment                            = require('moment'),
      BindAndFormatOptionValuesBehavior = require('fukit').BindAndFormatOptionValuesBehavior;

  var RequestLockModalView = UIKit.Modal2.extend({
    options: _.extend({}, UIKit.Modal2.prototype.options, {
      basic: true,
      closeable: false,
      size: 'small',
    }),

    internalViewOptions: UIKit.Modal2.extendInternalViewOptions({
      headerView: ExtendUtil.extendOptionValueWithDefaults('header', {}),

      contentView: ExtendUtil.extendOptionValueWithDefaults('content', function() {
        return {
          type: UIKit.Modal2.SimpleContentView,
          icon: 'warning sign',
          model: this.model,
        };
      }),

      actionsView: ExtendUtil.extendOptionValueWithDefaults('actions', {
        components: [
          {
            type: UIKit.Modal2.DenyButtonView,
            text: 'Cancel',
            inverted: true,
            color: 'basic',
            name: 'denyButton',
          },
          {
            type: UIKit.Modal2.DenyButtonView,
            text: 'Preview',
            inverted: true,
            color: 'basic',
            visible: false,
            name: 'previewButton',
          },
          {
            type: UIKit.Modal2.ConfirmButtonView,
            color: 'negative',
            text: 'Continue',
            name: 'confirmButton',
          },
        ],
      }),
    }),

    content: {
      behaviors: {
        BindAndFormatOptionValuesBehavior: {
          optionValues: {
            text: {
              formatter: function(lockModel) {
                var fullName = _.compact([lockModel.get('firstName'), lockModel.get('lastName')]).join(' ');
                fullName = '<b>' + fullName + '</b>';
                var lastEditDate = Moment(lockModel.get('createDate')).format('L LT');
                var space = '&nbsp;&nbsp;';

                var message =
                  'The page is currently being edited by ' +
                  fullName +
                  '.' +
                  space +
                  'Breaking the lock will discard any unsaved changes made by ' +
                  fullName +
                  ' ' +
                  'as of ' +
                  lastEditDate +
                  '.' +
                  space +
                  'Are you sure you want to continue?';

                return new Handlebars.SafeString(message);
              },
            },
          },
          behaviorClass: BindAndFormatOptionValuesBehavior,
        },
      },
    },
  });

  module.exports = RequestLockModalView;
});

